module.exports = __webpack_public_path__ + "static/media/bd3b3439-8eff-445c-80ed-87064138ca7d.124ae928.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/bd3b3439-8eff-445c-80ed-87064138ca7d.ttf
// module id = 91
// module chunks = 0